import { render, staticRenderFns } from "./Top3.vue?vue&type=template&id=95d8f654&scoped=true&"
import script from "./Top3.vue?vue&type=script&lang=js&"
export * from "./Top3.vue?vue&type=script&lang=js&"
import style0 from "./Top3.vue?vue&type=style&index=0&id=95d8f654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d8f654",
  null
  
)

export default component.exports